export default __webpack_public_path__ + "static/media/0xf244e91a46a9cdd48da295ca5d0b27894f8032b1.4fa00d31.webp";